module.exports = __webpack_public_path__ + "static/specimen1-35857f98852ff0515f3a0966303b0c9b.jpg";